import { render } from "./RequestPunctual.view.vue?vue&type=template&id=e6cc5e28"
import script from "./RequestPunctual.view.vue?vue&type=script&lang=js"
export * from "./RequestPunctual.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__